import React from "react";
import { BaseQuestionType, QuestionListItem } from "service/exercise";
import style from "./index.module.scss";
import { indexToChar } from "../../../../../utils/common";
import { isTrue } from "../../../../../service/service";

interface TopicDetailProps {
    data: QuestionListItem;
    index?: number;
}

export default function TopicDetail({ data, index }: TopicDetailProps) {
    function getRightOptions() {
        if (
            ![
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge
            ].includes(data.queTypeId)
        )
            return;

        return (
            data.optionModelList
                ?.map((item, index) => ({
                    ...item,
                    char:
                        data.queTypeId === BaseQuestionType.Judge
                            ? item.description
                            : indexToChar(index)
                }))
                .filter(item => isTrue(item.isRight))
                .map(item => item.char)
                .join("") || ""
        );
    }

    return (
        <div className={style.root}>
            <div className={style.info}>
                <em>{data?.index ? data.index : `(${index})`}.</em>（
                {data.queTypeName}，{data?.score ? data.score : 0}分）
            </div>

            <div className={style.trunk}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: data.contentText }}
                />
            </div>

            {/* 多选，单选选项 */}
            <div className={style.options}>
                {[
                    BaseQuestionType.SingleChoice,
                    BaseQuestionType.MultipleChoice
                ].includes(data.queTypeId) &&
                    data.optionModelList.map((item, index) => {
                        return (
                            <div key={item.id}>
                                {indexToChar(index)}.
                                <div
                                    className={style.option}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </div>
                        );
                    })}
            </div>

            {/* 正确答案 */}
            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <div className={style.answer}>
                    <h1>【正确答案】{getRightOptions()} </h1>

                    {data.queTypeId === BaseQuestionType.Fill &&
                        data.optionModelList.map((item, index) => (
                            <p key={item.id}>
                                填空{index + 1}：{item.description}
                            </p>
                        ))}
                </div>
            )}

            {/* 主观题有参考答案 */}
            {data.queTypeId === BaseQuestionType.Subjective && (
                <div className={style.answerSuggested}>
                    <h1>
                        参考答案{" "}
                        <span className={style.answerTip}>
                            (活动结束后学生可见)
                        </span>
                    </h1>
                    <div
                        className={style.option}
                        dangerouslySetInnerHTML={{
                            __html: data.analysis ? data.analysis : "无"
                        }}
                    />
                </div>
            )}
        </div>
    );
}
